$(document).ready(function() {
	if ($('.header-reviews-slider').length !== 0) {
		$('.header-reviews-slider').slick({
			dots: true,
			arrows: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 3000,
			speed: 1000,
			slidesToShow: 1,
			slidesToScroll: 1,
			responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: false,
					}
				},
				{
					breakpoint: 680,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			]
		});
	}
	
	/*
   if(".product_upsells_slider"){
      $('.product_upsells_slider').slick({
           dots: true,
           arrows: false,
           infinite: true,
           autoplay: false,
           autoplaySpeed: 3000,
           speed: 1000,
           slidesToShow: 1,
           slidesToScroll: 1,
           responsive: [{
               breakpoint: 1024,
               settings: {
                 slidesToShow: 1,
                 slidesToScroll: 1,
                 infinite: true,
               }
             },
             {
               breakpoint: 768,
               settings: {
                 slidesToShow: 1,
                 slidesToScroll: 1,
                 arrows: false,
               }
             },
             {
               breakpoint: 680,
               settings: {
                 slidesToShow: 1,
                 slidesToScroll: 1
               }
             }
              You can unslick at a given breakpoint now by adding:
              settings: "unslick"
              instead of a settings object
           ]
         });
   }
  */
	if ($('.premium-slider').length !== 0) {
		$('.premium-slider').slick({
			dots: false,
			arrows: true,
			infinite: false,
			prevArrow: "<img class='a-left control-c prev slick-prev' src='https://uploads-ssl.webflow.com/64b99cf470bd6bb713c553a0/64beb236bc0ce8dc87d65c91_prev.svg'>",
			nextArrow: "<img class='a-right control-c next slick-next' src='https://uploads-ssl.webflow.com/64b99cf470bd6bb713c553a0/64beb24051ca7e5ce3cad4a1_next.svg'>",
			speed: 300,
			slidesToShow: 4,
			slidesToScroll: 1,
			responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						infinite: true,
						dots: false
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						arrows: false
					}
				},
				{
					breakpoint: 580,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: false
					}
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			]
		});
	}

	if ($('.clients-slider').length !== 0) {
		$('.clients-slider').slick({
			dots: true,
			arrows: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 3000,
			speed: 1000,
			prevArrow: "<img class='a-left control-c prev slick-prev' src='https://uploads-ssl.webflow.com/648078008a0b10180df0484f/6480cd51cdbffb020f9f9fd3_c-prev.svg'>",
			nextArrow: "<img class='a-right control-c next slick-next' src='https://uploads-ssl.webflow.com/648078008a0b10180df0484f/6480cd51ea5626e2ab25a7cd_c-next.svg'>",
			speed: 300,
			slidesToShow: 4,
			slidesToScroll: 1,
			responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						dots: true
					}
				},
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						arrows: false,
					}
				},
				{
					breakpoint: 580,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: false
					}
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			]
		});
  }

	if ($('.other-products-slider').length !== 0) {
		$('.other-products-slider').slick({
			dots: false,
			arrows: true,
			infinite: false,
			prevArrow: "<img class='a-left control-c prev slick-prev' src='https://uploads-ssl.webflow.com/64b99cf470bd6bb713c553a0/64beb236bc0ce8dc87d65c91_prev.svg'>",
			nextArrow: "<img class='a-right control-c next slick-next' src='https://uploads-ssl.webflow.com/64b99cf470bd6bb713c553a0/64beb24051ca7e5ce3cad4a1_next.svg'>",
			speed: 300,
			slidesToShow: 4,
			slidesToScroll: 1,
			responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						infinite: true,
						dots: false
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						arrows: false
					}
				},
				{
					breakpoint: 580,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: false
					}
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			]
		});
	}

	if ($('.product-slider').length !== 0) {
		$('.product-slider').slick({
			autoplay: false,
			slidesToScroll: 1,
			slidesToShow: 1,
			arrows: true,
			prevArrow: "<img class='a-left control-c prev slick-prev' src='https://uploads-ssl.webflow.com/64b99cf470bd6bb713c553a0/64c7b8c00ecf41853aad991a_p-prev.svg'>",
			nextArrow: "<img class='a-right control-c next slick-next' src='https://uploads-ssl.webflow.com/64b99cf470bd6bb713c553a0/64c7b8c0fc334ca3a0ba05bb_p-next.svg'>",
			dots: false,
			asNavFor: '.product-slider-thumbnail'
		});
	}
	
	if ($('.product-slider-thumbnail').length !== 0) {
		$('.product-slider-thumbnail').slick({
			autoplay: false,
			infinite: true,
			slidesToShow: 4,
			slidesToScroll: 1,
			asNavFor: '.product-slider',
			dots: false,
			arrows: false,
			focusOnSelect: true,
			variableWidth: false,
			responsive: [{
					breakpoint: 480,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1
					}
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			]
		});
	}
	
  // Ao clicar em uma tab
  $('.how-works-tab-menu-link').on('click', function() {
    // Obtem o valor do atributo data-tab
    var tabId = $(this).data('tab');
    // Remove a classe 'active' de todas as abas e conteúdos
    $('.how-works-tab-menu-link').removeClass('active');
    $('.how-works-tab-content').removeClass('active');
    // Adiciona a classe 'active' à aba clicada e ao seu respectivo conteúdo
    $(this).addClass('active');
    $('#' + tabId).addClass('active');
  });

  handleCheckVariantBundleDiscountPrice();
});

var handleCheckVariantBundleDiscountPrice = function() {
  if ($('.product-form__input input[type="radio"]').length !== 0 && $('[data-id="product-ori-price"]').length !== 0) {
    var targetVariant = $('.product-form__input input[type="radio"]:checked').val();
    if (targetVariant && $('[data-price][data-variant-name="'+ targetVariant +'"]').length !== 0) {
      $('[data-id="product-ori-price"]').html($('[data-price][data-variant-name="'+ targetVariant +'"]').attr('data-price'));
    }
  }
  if ($('.product-form__input input[type="radio"]').length !== 0 && $('[data-id="product-promo-code-price"]').length !== 0) {
    var targetVariant = $('.product-form__input input[type="radio"]:checked').val();
    if (targetVariant && $('[data-promo-code-price][data-variant-name="'+ targetVariant +'"]').length !== 0) {
      $('[data-id="product-promo-code-price"]').html($('[data-promo-code-price][data-variant-name="'+ targetVariant +'"]').attr('data-promo-code-price'));
    }
  }
  if ($('.product-form__input input[type="radio"]').length !== 0 && $('[data-image-no]').length !== 0) {
    var targetVariant = $('.product-form__input input[type="radio"]:checked').val();
    if (targetVariant && $('[data-image-no][data-variant-name="'+ targetVariant +'"]').length !== 0) {
      $('.product-slider').slick('slickGoTo', $('[data-image-no][data-variant-name="'+ targetVariant +'"]').attr('data-image-no'));
    }
  }
}

  
$('.header-product-content-desc-readmore').click(function() {
  console.log("got clicked");
  $('.show_hidden').toggleClass('remove');
  $('.header-product-content-desc.hiddenn').toggleClass('hideblock');
  $('span.header-product-content-desc-readmore-span1').toggleClass('test');
  $('span.header-product-content-desc-readmore-span2').toggleClass('test');
});

if (window.matchMedia('(max-width: 890px)').matches) {
  console.log("checking in it");
  $("#Details-menu-drawer-container").click(function() {
    $('.navbar-inner-content').toggleClass("active-header");
  });
}

$(".included-info-box-wrap.pulse").click(function() {
  if ($(this).find('.included-info-box').hasClass("shown")) {
    $(this).find('.included-info-box').addClass("hidn");
    $(this).find('.included-info-box').removeClass("shown");
  } else {
    $(".included-info-box").removeClass("shown");
    $(".included-info-box").addClass("hidn");
    $(this).find('.included-info-box').addClass("shown");
    $(this).find('.included-info-box').removeClass("hidn");
  }
});

$(".question-wrapper-f44").click(function() {
  if ($(this).hasClass("hdn")) {
    $(".question-wrapper-f44").addClass("hdn", 200, "linear");
    $(this).removeClass("hdn", 200, "linear");
  } else {
    $(this).addClass("hdn", 200, "linear");

  }
});
$(".header-product-content-faq-wrap .faq-wrap-2").click(function() {
  if ($(this).hasClass("hdn")) {
    $(".faq-wrap-2").addClass("hdn", 200, "linear");
    $(this).removeClass("hdn", 200, "linear");
  } else {
    $(this).addClass("hdn", 200, "linear");
  }
});
$(".faq-box .faq-wrap-2").click(function() {
  if ($(this).hasClass("hdn")) {
    $(".faq-wrap-2").addClass("hdn", 200, "linear");
    $(this).removeClass("hdn", 200, "linear");
  } else {
    $(this).addClass("hdn", 200, "linear");
  }
});

if (window.matchMedia('(max-width: 768px)').matches) {
	if ($('.best-sellers-row').length !== 0) {
		$('.best-sellers-row').slick({
			dots: true,
			arrows: false,
			infinite: true,
			speed: 1000,
			slidesToShow: 3,
			slidesToScroll: 1,
			responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						infinite: true,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: false,
					}
				},
				{
					breakpoint: 680,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			]
		});
	}
};

const today = new Date();
const nextThreeDays = new Date(today.setDate(today.getDate() + 4));
const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];
console.log(monthNames[nextThreeDays.getMonth()])
var finalDate = monthNames[nextThreeDays.getMonth()] + " " + nextThreeDays.getDate() + " " + nextThreeDays.getFullYear();
console.log(finalDate, "finalDate");
$(".header-product-content-ships-text-span").text(finalDate);

$(".quick-add button").click(function() {
  setTimeout(function() {
    $('.header-product-content-desc-readmore').click(function() {
      console.log("got clicked");
      $('.show_hidden').toggleClass('remove');
      $('.header-product-content-desc.hiddenn').toggleClass('hideblock');
      $('span.header-product-content-desc-readmore-span1').toggleClass('test');
      $('span.header-product-content-desc-readmore-span2').toggleClass('test');
    });
    $(".question-wrapper-f44").click(function() {
      if ($(this).hasClass("hdn")) {
        $(".question-wrapper-f44").addClass("hdn", 200, "linear");
        $(this).removeClass("hdn", 200, "linear");
      } else {
        $(this).addClass("hdn", 200, "linear");

      }
    });
    $(".header-product-content-faq-wrap .faq-wrap-2").click(function() {
      if ($(this).hasClass("hdn")) {
        $(".faq-wrap-2").addClass("hdn", 200, "linear");
        $(this).removeClass("hdn", 200, "linear");
      } else {
        $(this).addClass("hdn", 200, "linear");
      }
    });
    if ($('.header-reviews-slider').length !== 0) {
			$('.header-reviews-slider').slick({
				dots: true,
				arrows: false,
				infinite: true,
				autoplay: true,
				autoplaySpeed: 3000,
				speed: 1000,
				slidesToShow: 1,
				slidesToScroll: 1,
				responsive: [{
						breakpoint: 1024,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							infinite: true,
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							arrows: false,
						}
					},
					{
						breakpoint: 680,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
				]
			});
    }
  }, 2000);
});

$(".follow-ig-post-item").click(function(e) {
  e.preventDefault();
  var thumbID = $(this).attr('value');
  console.log(thumbID);
  // var popID = $(".follow-ig-popup-wrap").attr('value');
  // console.log(popID);
  $('.follow-ig-popup-wrap[value="' + thumbID + '"]').css({
    "display": "flex",
    "opacity": "1"
  });
});
$(".follow-ig-close-popup-link").click(function() {
  $(this).closest(".follow-ig-popup-wrap").css({
    "display": "none",
    "opacity": "0"
  });
});







// Select all video placeholders
const videoPlaceholders = document.querySelectorAll('.video-placeholder');

// IntersectionObserver options
const options = {
  root: null,
  rootMargin: '0px',
  threshold: 0.5
};

// IntersectionObserver callback function
function handleIntersection(entries, observer) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.innerHTML = entry.target.innerHTML.replace(/<!--/g, '').replace(/-->/g, '');
      const video = entry.target.querySelector('video');
      if (video) {
        video.play();
      }
      observer.unobserve(entry.target);
    }
  });
}

// Create IntersectionObserver instance
const observer = new IntersectionObserver(handleIntersection, options);

// Observe each video placeholder
videoPlaceholders.forEach(placeholder => {
  observer.observe(placeholder);
});